import type { components } from '../../api/schema.gen.ts';
import { apiFetch } from '../../api/http.ts';

/**
 * Aliased from the generated OpenAPI types — see the note in itemsApi.ts. Members carry
 * both colour renderings because no single hex is readable on both themes.
 */
type Schemas = components['schemas'];

export type GroupMember = Schemas['GroupMemberResponse'];
export type Group = Schemas['GroupResponse'];

/**
 * Who may invite: the owner always, everyone else only when the owner has opened it up.
 * It decides both whether the menu offers Invite and whether the form draws itself, so it
 * lives here rather than being spelled out at each of them.
 */
export function canInvite(group: Group): boolean {
  return group.yourRole === 'Owner' || group.allowMemberInvites;
}

export const groupKeys = {
  all: ['groups'] as const,
  detail: (groupId: string) => ['groups', groupId] as const,
};

export function listGroups(): Promise<Group[]> {
  return apiFetch<Group[]>('/api/groups');
}

export function createGroup(name: string): Promise<Group> {
  return apiFetch<Group>('/api/groups', { method: 'POST', json: { name } });
}

export function updateGroup(
  groupId: string,
  update: { name: string; allowMemberInvites: boolean },
): Promise<Group> {
  return apiFetch<Group>(`/api/groups/${groupId}`, { method: 'PUT', json: update });
}

export function removeMember(groupId: string, userId: string): Promise<void> {
  return apiFetch<void>(`/api/groups/${groupId}/members/${userId}`, { method: 'DELETE' });
}
